import { store } from '../../../store';
import { app } from '../../index';
import { getOnlyAlphaNums } from '../../../utils/getOnlyAlphaNums';

export const getCustomerByPhone = async (customerPhone) => {
  try {
    const db = app.firestore();
    const { establishment: { id } } = store.getState();
    const data = await db
      .collection('customers')
      .where('establishmentId', '==', id)
      .where('phone', '==', customerPhone)
      .get();

    if (data.empty) return {};

    return {
      ...data.docs[0].data(),
      id: data.docs[0].id,
    };
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const getCustomerById = async (customerId) => {
  try {
    const db = app.firestore();
    const { establishment: { id } } = store.getState();
    const data = await db
      .collection('customers')
      .doc(customerId)
      .get();

    if (data.empty) return {};

    const customerData = data.data();
    if (customerData && customerData.establishmentId === id) {
      return {
        ...customerData,
        id: data.id,
      };
    }

    return {};
  } catch (err) {
    console.log(err);
    return [];
  }
};

const toNationalDigits = (value) => {
  let digits = getOnlyAlphaNums(String(value || '')) || '';
  if (digits.length > 11 && digits.startsWith('55')) digits = digits.slice(2);
  return digits;
};

export const getCustomerByPhoneNumber = async (rawPhone) => {
  try {
    const target = toNationalDigits(rawPhone);
    if (!target || target.length < 10) return null;

    const db = app.firestore();
    const { establishment: { id } } = store.getState();
    const data = await db
      .collection('customers')
      .where('establishmentId', '==', id)
      .get();

    if (data.empty) return null;

    const match = data.docs.find(
      (doc) => toNationalDigits(doc.data().phone) === target,
    );

    return match ? { ...match.data(), id: match.id } : null;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getCustomerByWhatsappId = async (whatsappId) => {
  try {
    if (!whatsappId) return null;

    const db = app.firestore();
    const { establishment: { id } } = store.getState();
    const data = await db
      .collection('customers')
      .where('establishmentId', '==', id)
      .get();

    if (data.empty) return null;

    const match = data.docs.find((doc) => doc.data().whatsappId === whatsappId);
    return match ? { ...match.data(), id: match.id } : null;
  } catch (err) {
    console.log(err);
    return null;
  }
};
